import {
  imageMap,
  moveName,
} from 'modules/stream-room-page/components/move-cards/move-cards.utils';

import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { MovesEnum } from 'shared/constants/shared-enums';
import useMediaQuery from 'shared/hooks/useMediaQuery';
import { Phase } from 'shared/store/stream-store';

interface MoveCardsProps {
  position: 'left' | 'right';
  selectedMove: MovesEnum;
  isWinner: boolean;
  isRoundFinished: boolean;
  roundDraw: boolean;
  currentPhase: Phase;
  isGameFinished: boolean;
}

export const MoveCards = ({
  position,
  selectedMove,
  isWinner,
  isRoundFinished,
  roundDraw,
  currentPhase,
  isGameFinished,
}: MoveCardsProps) => {
  const isMobile = useMediaQuery('(max-width: 767px)');

  if ((currentPhase === 'done' || isGameFinished) && isMobile) {
    return null;
  }

  if (selectedMove === MovesEnum.None || !isRoundFinished || isGameFinished) {
    return null;
  }

  const prefix = position === 'left' ? 'me' : 'opponent';

  const suffix = () => {
    if (roundDraw) return '';
    return isWinner ? 'win' : 'lost';
  };

  const key = suffix()
    ? `${prefix}-${moveName(selectedMove)}-${suffix()}`
    : `${prefix}-${moveName(selectedMove)}`;

  const imageData = imageMap[key];

  return (
    <div
      className={`relative z-30 transition-opacity duration-500 ease-in-out ${
        isRoundFinished ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
      }`}
    >
      <OptimizedImage
        className={`w-[50px] sm:w-[101px] ${
          !isMobile ? (position === 'left' ? 'rotate-[30deg]' : 'rotate-[-30deg]') : ''
        }`}
        imageData={imageData}
        alt={`${position} ${moveName(selectedMove)} ${suffix() || 'draw'}`}
      />
    </div>
  );
};
